module.exports = __webpack_public_path__ + "static/img/JCI_polling.7bc7732.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/JCI_polling.png
// module id = q+2v
// module chunks = 1